import React from 'react';
import { TextLinkProps } from './props';
import { TypedMemo } from '../../types';
import { ClickableDiv } from '../ClickableDiv';

const TextLinkComponent: React.FC<React.PropsWithChildren<TextLinkProps>> = ({ children, onClick }) => {
  return (
    <ClickableDiv onClick={onClick} className="m-2 ui-text">
      <span className="text-body text-decoration-underline">{children}</span>
    </ClickableDiv>
  );
};

export const TextLink = TypedMemo(TextLinkComponent);
